<template>
  <div id="main" class="ssss">
    <!-- <div class="pro">
    <div id="ecc"></div>
    </div> -->
    <div class="acc">
        <div class="op">
    <Candode v-on:childByValue="childByValue" ></Candode>
<div class="add">
    <el-date-picker
      v-model="time"
      size='mini'
      type="daterange"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      :picker-options="pickerOptions"
      >
    </el-date-picker>
</div>
  <div class="add" >
  <el-select size="mini" v-model="cblx" placeholder="补贴类型">
    <el-option
      v-for="item6 in cblxList"
      :key="item6.value"
      :label="item6.label"
      :value="item6.value">
    </el-option>
  </el-select>
</div>
<div class="add">
    <el-select size="mini" clearable v-model="age" placeholder="选择年龄">
    <el-option
      v-for="item4 in ageList"
      :key="item4.value"
      :label="item4.label"
      :value="item4.value">
    </el-option>
  </el-select>
</div>
<!-- <div class="add">
    <el-select size="mini" clearable v-model="agemeth" placeholder="年龄计算方式">
    <el-option
      v-for="item5 in agemethList"
      :key="item5.value"
      :label="item5.label"
      :value="item5.value">
    </el-option>
  </el-select>
</div> -->
<el-button type="primary" size="mini" style="background:#148A9B;margin-left:10px" icon="el-icon-search" @click="serch">查询</el-button>
</div>
<div class="cont" >
  <div class="upt">

    <div class="ron" v-loading="loading1">
      <p class="ageWrap">认证比例(已认证/总人数)</p>
      <!-- <p class="contt">{{bl}}</p> -->
      <div class="contt">
          <div class="clft">
              <div class="overauth"><div class="ss"><span>已认证</span><br><span>{{yrz}}</span></div></div>
              <div class="noauth"><div class="ss"><span>未认证</span><br><span>{{wrz}}</span></div></div>
          </div>
          <div class="alcont"><div class="ss"><span>总人数</span><br><span>{{zs}}</span></div></div>
           <div class="alcont bls"><div class="ss"><span>比例</span><br><span>{{rate}}</span></div></div>
          </div>
    </div>

    <div class="ron" v-loading="loading1">
      <p class="ageWrap">今日认证量</p>
      <div class="contt"><div class="overreg">{{authNum}}</div></div>
    </div>
    <div class="ron" v-loading="loading1">
      <p class="ageWrap">
        核减人数
        <!-- <el-select size="mini" @change="getHj" v-model="hjrs" placeholder="">
    <el-option
      v-for="(items,index) in hjrsList"
      :key="index"
      :label="items.label"
      :value="items.value">
    </el-option>
  </el-select> -->
      </p>
      <div class="contt"><div class="overreg desc">{{hj}}</div></div>
    </div>
  </div>
  <div class="bt">
  <div class="chart" v-loading="loading2">
    <p class="ageWrap">年龄分布</p>
    <div id="chart2"></div>
    </div>
    <div class="chart2" v-loading="loading3">
    <p class="ageWrap">补贴类型</p>
    <div id="chart"></div>
    </div>
     <div class="chart3" v-loading="loading4">
    <p class="ageWrap">新增人数</p>
    <div id="chart3"></div>
    </div>
    </div>
  </div>
    </div>
  </div>
</template>

<script>
var echarts = require("echarts");
import Candode from "../Core/candode";
import { china } from "../../utils/json/china";
import { getType } from "../../utils/typeAuth";
import getNowMonth from "../../utils/getNowMonth";
import { formatDate } from "../../utils/datetime";
import { Loading } from "element-ui";
export default {
  components: {
    Candode
  },
  data() {
    return {
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      yrz: "",
      hj: "",
      wrz: "",
      zs: "",
      rate: "",
      timer: null,
      bl: "",
      hjrs: "",
      hjrsList: [
        {
          value: "",
          label: "核减人数"
        },
        {
          value: getNowMonth(),
          label: "当月核减"
        }
      ],
      chart3: [],
      chart3x: [],
      authNum: "",
      uplist: {
        addCount: 0,
        authNum: "",
        colCount: "",
        dieCount: 0,
        haveMoney: 0,
        moneyCount: 0
      },
      townList: [],
      age: "",
      time: "",
      authCount: "",
      // ageList:[{
      //   value:"",
      //   label:"所有年龄段",
      // },{
      //   value:"1",
      //   label:"55岁以下",
      // },{
      //   value:"2",
      //   label:"55岁-59岁",
      // },{
      //   value:"3",
      //   label:"60岁-80岁",
      // },{
      //   value:"4",
      //   label:"80岁-90岁",
      // },{
      //   value:"5",
      //   label:"90岁-100岁",
      // },{
      //   value:"6",
      //   label:"100岁以上",
      // }],
      ageList: [
        {
          value: "1",
          label: "80岁以上"
        },
        {
          value: "2",
          label: "80岁以下"
        }
      ],
      //年龄计算方式
      agemeth: "1",
      agemethList: [
        {
          value: "1",
          label: "按年计算"
        },
        {
          value: "2",
          label: "按月计算"
        }
      ],
      //补贴类型
      cblx: "",
      cblxList: [],
      data: "",
      data2: "",
      data3: "",
      agex: "",
      eve: {},
      options: "",
      options2: "",
      options3: "",
      ax: "",
      ay: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "1月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 0, 1);
              const end = new Date(year, 1, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "2月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 1, 1);
              const end = new Date(year, 2, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "3月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 2, 1);
              const end = new Date(year, 3, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "4月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 3, 1);
              const end = new Date(year, 4, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "5月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 4, 1);
              const end = new Date(year, 5, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "6月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 5, 1);
              const end = new Date(year, 6, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "7月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 6, 1);
              const end = new Date(year, 7, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "8月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 7, 1);
              const end = new Date(year, 8, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "9月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 8, 1);
              const end = new Date(year, 9, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "10月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 9, 1);
              const end = new Date(year, 10, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "11月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 10, 1);
              const end = new Date(year, 11, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "12月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 11, 1);
              const end = new Date(year, 12, 0);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    formatDate: formatDate,
    childByValue(val) {
      this.townList = val;
      // this.serchCode()
    },
    getHj() {
      console.log(this.hjrs);
    },
    getJson() {
      echarts.registerMap("HK", china);
      var myChart = echarts.init(document.getElementById("ecc"));
      myChart.setOption({
        title: {
          text: "省级认证数量统计"
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}<br/>认证人数:{c}"
        },

        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            dataView: { readOnly: false },
            restore: {},
            saveAsImage: {}
          }
        },
        visualMap: {
          min: 800,
          max: 50000,
          text: ["High", "Low"],
          realtime: false,
          calculable: true,
          inRange: {
            color: ["#EEF1F4", "#227AFD"]
          }
        },
        series: [
          {
            type: "map",
            mapType: "HK", // 自定义扩展图表类型
            itemStyle: {
              normal: {
                label: { show: false },
                areaColor: "#EEF1F4",
                borderColor: "#F8F8F8"
              },
              emphasis: { label: { show: true } }
            },
            data: [{ name: "安徽", value: 20057.34 }]
            // 自定义名称映射
          }
        ]
      });
    },
    getCircle() {
      this.options = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        color: [
          "#67C23A",
          "#F56C6C",
          "#909399",
          "blue",
          "#357EB9",
          "#9126DD",
          "#265D0A",
          "#141293"
        ],

        legend: {
          orient: "horizontal",
          top: "5%",
          x: "center",
          y: "top",
          data: this.ax
        },
        series: [
          {
            name: "人数统计",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "30",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: this.ay
          }
        ]
      };
      this.options2 = {
        xAxis: {
          type: "category",
          data: this.chart3x
        },
        yAxis: {
          type: "value"
        },
        grid: {
          left: 70
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        series: [
          {
            data: this.chart3,
            type: "line"
          }
        ]
      };

      this.options3 = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        color: ["#67C23A", "#F56C6C", "#909399", "blue", "#357EB9", "#9126DD"],

        legend: {
          orient: "horizontal",
          top: "5%",
          x: "center",
          y: "top",
          data: this.agex
        },
        series: [
          {
            name: "人数统计",
            type: "pie",
            radius: ["0%", "70%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "30",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: this.data3
          }
        ]
      };
    },
    event() {
      this.eve = {
        province_name: this.townList[0] ? this.townList[0].split(",")[0] : "",
        city_name: this.townList[1] ? this.townList[1].split(",")[0] : "",
        county_name: this.townList[2] ? this.townList[2].split(",")[0] : "",
        town_name: this.townList[3] ? this.townList[3].split(",")[0] : "",
        village_name: this.townList[4] ? this.townList[4].split(",")[0] : "",
        province: this.townList[0] ? this.townList[0].split(",")[1] : "",
        city: this.townList[1] ? this.townList[1].split(",")[1] : "",
        county: this.townList[2] ? this.townList[2].split(",")[1] : "",
        town: this.townList[3] ? this.townList[3].split(",")[1] : "",
        village: this.townList[4] ? this.townList[4].split(",")[1] : "",
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        birthday: this.age,
        verify_type: this.cblx,
        start_time: this.time ? this.time[0] : "",
        end_time: this.time ? this.time[1] : "",
        quarry_rule: this.agemeth
      };
    },
    serch() {
      // const isTown = this.townList[2] ? this.townList[2].split(",")[0] : "";
      // if (!isTown) {
      //   this.$message({
      //     type: "warning",
      //     message: "请选择县/区及以下区域进行操作"
      //   });
      //   return;
      // }
      this.loading1 = true;
      this.loading2 = true;
      this.loading3 = true;
      this.loading4 = true;
      this.event();
      this.chartOne();
      this.chartTwo();
      this.chartThree();
      this.chartThree4();
      this.$api.getlist
        .chartAllcount(this.eve)
        .then(res => {
          this.loading1 = false;
          let result = res.data;
          this.yrz = result.已认证;
          this.wrz = result.未认证;
          this.zs = result.总数;
          this.rate = result.认证比例 + "%";
        })
        .catch(res => {
          this.loading1 = false;
        });
    },
    chartOne() {
      this.$api.getlist
        .chartAuthcount(this.eve)
        .then(res => {
          this.loading1 = false;
          if (res.code == 200) {
            this.authNum = res.data;
          } else {
            this.$message({
              type: "warning",
              message: data.message
            });
          }
        })
        .catch(err => {
          this.loading1 = false;
        });
    },
    chartTwo() {
      this.$api.getlist
        .chartAgecount(this.eve)
        .then(res => {
          this.loading2 = false;
          if (res.code == 200) {
            this.agex = res.data.x;
            this.data3 = res.data.y;
            this.getCircle();
            let myChart2 = echarts.init(document.getElementById("chart2"));
            myChart2.setOption(this.options3);
          } else {
            this.$message({
              type: "warning",
              message: data.message
            });
          }
        })
        .catch(err => {
          this.loading2 = false;
        });

      this.$api.getlist
        .chartSubcount(this.eve)
        .then(res => {
          if (res.code == 200) {
            this.hj = res.data;
          } else {
            this.$message({
              type: "warning",
              message: data.message
            });
          }
        })
        .catch(err => {});
    },
    chartThree() {
      let data = {};
      this.chart3 = [];
      this.$api.getlist
        .chartInscrcount(this.eve)
        .then(res => {
          this.loading4 = false;
          if (res.code == 200) {
            this.uplist = res.data;
            this.chart3 = res.data.y;
            this.chart3x = res.data.x;
            this.getCircle();

            let myChart3 = echarts.init(document.getElementById("chart3"));
            myChart3.setOption(this.options2);
          } else {
            this.$message({
              type: "warning",
              message: data.message
            });
          }
        })
        .catch(err => {
          this.loading4 = false;
        });
    },
    chartThree4() {
      let data = {};
      this.$api.getlist
        .chartVerifytypecount(this.eve)
        .then(res => {
          this.loading3 = false;
          if (res.code == 200) {
            this.uplist = res.data;
            this.ay = res.data.y;
            this.ax = res.data.x;
            this.getCircle();
            let myChart4 = echarts.init(document.getElementById("chart"));
            myChart4.setOption(this.options);
          } else {
            this.$message({
              type: "warning",
              message: data.message
            });
          }
        })
        .catch(err => {
          this.loading3 = false;
        });
    }
  },
  mounted() {
    //this.getJson()
    this.serch();
    setInterval(() => {
      this.chartOne();
    }, 600000);
  },
  created() {
    let city = JSON.parse(sessionStorage.getItem("list")).city;
    if (city) {
      if (city.split(",")[1] == "潍坊市") {
        this.time = getNowMonth();
      } else {
        this.time = "";
      }
    }
    let arr;
    if (sessionStorage.getItem("typeControll") == "null") {
      arr = JSON.parse(sessionStorage.getItem("codes"));
    } else {
      arr;
      arr = JSON.parse(sessionStorage.getItem("typeControll"));
      arr.unshift("");
    }
    this.event();
    //  this.timer=setInterval(() => {
    //   this.chartOne()
    // this.chartTwo()
    // this.chartThree()
    // }, 10000);

    for (let i in arr) {
      this.cblxList.push({
        label: getType(arr[i]),
        value: arr[i]
      });
    }
    this.cblx = arr[0];
  },
  destroyed() {
    //       console.log(this.timer)
    // clearInterval(this.timer)
    // this.timer=null
  }
};
</script>

<style>
html,
body {
  background: #f5f5f5;
}

.overreg {
  display: flex;
  font-size: 30px;
  color: green;
  align-items: center;
}
.desc {
  color: red;
}
.ssss .contt {
  justify-content: center;
  min-height: 110px;
  padding: 15px;
  color: #438bac;
  font-size: 22px;
  font-weight: bolder;
  display: flex;
}
.ss {
  text-align: center;
}
.ss span {
  display: inline-block;
  margin-top: 5px;
}
.clft {
  width: 30%;
  font-size: 16px;
  color: #ffffff;
}
.overauth,
.noauth {
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: #f1739e;
}
.noauth {
  margin-top: 4px;
  background: #49a9f5;
}
.alcont {
  width: 30%;
  font-size: 16px;
  border-radius: 5px;
  margin-left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background: #c177cd;
}
.bls {
  background: #41b0a6;
  color: #ffffff;
}
.bt {
  display: flex;
  justify-content: space-between;
  height: 60vh;
}
.chart,
.chart2,
.chart3 {
  width: 32%;
  background: #ffffff;
  border-radius: 5px;
}
#chart {
  height: 100%;
  width: 100% !important;
  float: left;
}
#chart2 {
  height: 100%;
  width: 100% !important;
  float: left;
}
#chart3 {
  height: 90%;
  width: 90%;
  margin-left: 30px;
  float: left;
}
.op {
  display: flex;
  margin-bottom: 20px;
}
.add {
  margin-left: 10px;
}
.ageWrap {
  border-bottom: 1px solid lightgray;
  padding: 15px;
  margin: 0;
  color: gray;
}
.upt {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.ssss .ron {
  width: 32% !important;
  background: #ffffff;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/Intro/Charts.vue